var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('SensorBlock',{staticClass:"py-5",attrs:{"sensors":this.sensors}}),_c('v-divider'),_c('EntityTable',{attrs:{"name":"Threads","headers":_vm.thread_headers,"items":_vm.threads}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }